
let concat = "<br />";

const aboutkb25 = {
    "About KrazyBee May’25": [
        {
          question: "What are the important details of the Bond offering?",
          answer: "Issuer Name: KrazyBee Services Private Limited" + concat +
          "Security Name: KRAZYBEE FINANCE LIMITED SR A 11.71 NCD 01JL25 FVRS1LAC" + concat +
          "ISIN: INE07HK07643" + concat +
          "Nature of Instrument: Rated, Listed, Secured, Transferable, Redeemable Non-Convertible Debentures" + concat +
          "Seniority: Senior" + concat +
          "Date of Issue: 30th November 2023" + concat +
          "Credit Rating: CRISIL A-/ Stable Outlook" + concat +
          "Face Value: Rs. 1,00,000/Unit" + concat +
          "Coupon: Fixed" + concat +
          "Coupon Rate: 11.80%" + concat +
          "Coupon Frequency: Annual" + concat +
          "Principal Repayment: At Maturity" + concat +
          "Original Mode of Issue: Private Placement" + concat +
          "Listing Details: Bombay Stock Exchange (BSE)" + concat +
          "Maturity Date: 30th May 2025" + concat +
          "Tenor: 18 months" + concat +
          "Debenture Trustee: Vardhaman Trusteeship Limited" + concat 
        },
        {
          question: "What is the Security Cover for the Bond?",
          answer: "The Bond is secured by way of a first ranking, exclusive and continuing charge on identified loan receivables for 1.1x the outstanding amount of the Bond (including Interest accrued)."
        },
        {
          question: "What are the important covenants that the Issuer has to adhere to?",
          answer: "a. The Capital Adequacy Ratio (Tier 1 and Tier 2 capital) to be maintained above 20%" + concat +
                  "b. Total Debt/ TNW not to exceed 2.5x" + concat +
                  "c. Maximum permissible ratio of PAR 90+ write offs for trailing 12 months to total loan disbursements of trailing 12 months shall be 6%" + concat +
                  "d. PAR of more than 90 days should not exceed 20% of the tangible Net worth" + concat +
                  "e. Cumulative Asset Liability Mismatch should always be positive in all buckets up to 1 year"  + concat + concat +

                  "PAR 90 shall mean outstanding principal amount of all clients that have one or more instalments of principal past due for 90 days or more."

        },
        {
          question: "Can I liquidate the bond before maturity?",
          answer: "Yes, you can liquidate the bond before maturity through our anytime liquidation feature. However, the liquidation will happen at a discount of 2% to the value of the bond."
        },
        {
          question: "How is the Yield to Maturity (YTM) is calculated?",
          answer: "The Yield to Maturity is calculated using the XIRR formula present in Microsoft Excel or such other spreadsheets. The cash flow is populated in the spreadsheet along with the dates and the XIRR formula is then applied to get the YTM."
        }
    ],
  }
  
  export default aboutkb25;